var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7271 0H2.27236C0.533955 0 -0.567869 1.87519 0.306688 3.39105L6.14183 13.5047C6.52259 14.1651 7.47687 14.1651 7.85763 13.5047L13.694 3.39105C14.5673 1.87757 13.4655 0 11.7283 0H11.7271ZM6.13707 10.4718L4.86629 8.01241L1.79998 2.52842C1.5977 2.17741 1.84758 1.72765 2.27117 1.72765H6.13588V10.473L6.13707 10.4718ZM12.1971 2.52723L9.13199 8.0136L7.8612 10.4718V1.72646H11.7259C12.1495 1.72646 12.3994 2.17622 12.1971 2.52723Z",
    fill: "#3DA3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondTon);
export default __webpack_public_path__ + "static/media/diamond-ton.715c7bfaaad415e2bab1a0704215ee43.svg";
export { ForwardRef as ReactComponent };